const truncateText = (text: string, num?: number) => {
  return num && text.length > num ? `${text.substr(0, num)}...` : text;
};

export default truncateText;